import { FormattedMessage } from 'react-intl';

export type SplitRow = { key: string; name: string; weight: number };

export const toDataSource = (split: Record<string, number>): SplitRow[] =>
  Object.entries(split).map(([name, weight]) => ({ key: name, name, weight }));

const renderWeight = (value: number) =>
  `${(value / 1000).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })} MT`;

const weightSorter = (a: SplitRow, b: SplitRow) => a.weight - b.weight;

export const productColumns = [
  {
    title: <FormattedMessage id="dashboard.productName" />,
    dataIndex: 'name',
    key: 'name',
  },
  {
    title: <FormattedMessage id="dashboard.productWeight" />,
    dataIndex: 'weight',
    key: 'weight',
    sorter: weightSorter,
    defaultSortOrder: 'descend' as const,
    render: renderWeight,
  },
];

export const harborColumns = [
  {
    title: <FormattedMessage id="dashboard.harborName" />,
    dataIndex: 'name',
    key: 'name',
  },
  {
    title: <FormattedMessage id="dashboard.harborWeight" />,
    dataIndex: 'weight',
    key: 'weight',
    sorter: weightSorter,
    defaultSortOrder: 'descend' as const,
    render: renderWeight,
  },
];

export const consortiumColumns = [
  {
    title: <FormattedMessage id="dashboard.consortiumName" />,
    dataIndex: 'name',
    key: 'name',
  },
  {
    title: <FormattedMessage id="dashboard.consortiumWeight" />,
    dataIndex: 'weight',
    key: 'weight',
    sorter: weightSorter,
    defaultSortOrder: 'descend' as const,
    render: renderWeight,
  },
];
